import { Post } from '@/service/request/server';
import { envConfig } from '../../../../env';

let baseUrl = envConfig.formalServer + '/cotton/monitor';

export function monitorCustomApi(data) {
    return Post(baseUrl + '/monitorCustomApi', data);
}

export function queryManualApiTestResult() {
    return Post(baseUrl + '/queryManualApiTestResult', {});
}

export function queryQQMonitorData() {
    return Post(baseUrl + '/queryQQMonitorData', {});
}